import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationMessageInfoDataService {

  constructor(private dataService: DataService) { }

  saveNotification(notification: string) {
    return this.dataService.post('/api/notificationMessageInfo/saveNotification', notification)
  }

   GetOtpNotificationMessage() {
    return this.dataService.getData('/api/NotificationMessageInfo/GetOtpNotificationMessage', true)
  }
}
